"use client";

import * as SwitchPrimitives from "@radix-ui/react-switch";
import * as React from "react";

import { css, sva } from "@/../styled-system/css";

const switchRecipe = sva({
  slots: ["root", "thumb"],
  base: {
    root: {
      display: "inline-flex",
      h: "24px",
      w: "44px",
      flexShrink: 0,
      cursor: "pointer",
      alignItems: "center",
      rounded: "full",
      border: "2px solid transparent",
      transition: "colors",
      _focusVisible: {
        outline: "2px solid transparent",
        outlineOffset: "2px",
        ringWidth: "2",
        ringColor: "black",
        ringOffset: "1",
      },
      _disabled: {
        cursor: "not-allowed",
        opacity: "0.5",
      },
      "&[data-state=checked]": {
        bg: "black",
      },

      "&[data-state=unchecked]": {
        bg: "black/25",
      },
    },
    thumb: {
      pointerEvents: "none",
      display: "block",
      h: "20px",
      w: "20px",
      rounded: "full",
      bg: "white",
      shadow: "lg",
      ring: "none",
      transition: "all 0.15s ease-in-out",
      translate: "auto",
      "&[data-state=checked]": {
        translateX: "20px",
      },
      "&[data-state=unchecked]": {
        translateX: "0",
      },
    },
  },
});

const { root, thumb } = switchRecipe.raw();

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
    css?: object;
  }
>(({ css: cssProp = {}, ...props }, ref) => {
  const className = css(root, cssProp);
  return (
    <SwitchPrimitives.Root className={className} {...props} ref={ref}>
      <SwitchPrimitives.Thumb className={css(thumb)} />
    </SwitchPrimitives.Root>
  );
});
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
